import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[color:var(--bg)] text-[color:var(--text)] grain">
      <Header />
      <main data-testid="main-content">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
